import React from "react";
import { Helmet } from "react-helmet-async";
import { ogImageUrl, SITE_URL } from "../lib/ogImages";

const LOCALES = { tr: "tr_TR", en: "en_US", es: "es_ES", de: "de_DE", fr: "fr_FR", ar: "ar_AR" };

/**
 * SeoHead — one component, every SEO/social tag, exactly once per page.
 *
 *  <SeoHead title="…" description="…" path={`/${lang}/about`} imageKey="about" lang={lang} />
 *
 * Emits: <title>, description, canonical (single, absolute), og:*, twitter:*.
 * Pass `image` (absolute URL) to override `imageKey` (e.g. blog cover images).
 */
export default function SeoHead({
  title,
  description = "",
  path = "/",
  imageKey = "home",
  image,
  type = "website",
  lang = "tr",
  themeColor,
  children,
}) {
  const canonical = `${SITE_URL}${path.startsWith("/") ? path : `/${path}`}`;
  const img = image || ogImageUrl(imageKey, lang);
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonical} />
      <meta property="og:type" content={type} />
      <meta property="og:url" content={canonical} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={img} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:locale" content={LOCALES[lang] || "tr_TR"} />
      <meta property="og:site_name" content="Yastık Medya" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={img} />
      {themeColor && <meta name="theme-color" content={themeColor} />}
      {children}
    </Helmet>
  );
}
